import { Rental } from "@/models/rental.entity";
import rentalService from "@/services/mrfiktiv/services/rental.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class RentalFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.RENTAL;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.RENTAL, async () => {
      const response = await rentalService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      return new Rental(response.rental);
    });
  }
}
